<template>
  <div class="pt-2 newrequestlist__wrapper2">
    <div class="text-center" v-if="isLoadingRfq || isLoadingRfqFilter || isLoadingContract || isLoadingContractFilter">
      <b-spinner label="Loading..."></b-spinner>
    </div>
    <div v-else-if="requestList.length === 0" class="_global__nodata d-flex justify-content-center align-items-center">
      <div class="text-center">
        <img src="@/assets/image/icon/nodata-requestlist.svg" alt="">
        <h4 class="pt-3">Currently you don’t have any on this request list</h4>
        <h6 class="pt-2">You can make a new shipment by clicking 'Shipment' button in side bar menu</h6>
      </div>
    </div>
    <div v-else-if="selectedtabs !== 'instant-quote' && tabActiveFailed !== 'Instant-Quote'">
      <div class="row m-0 mb-2" v-for="(item, i) in requestList" :key="i" :class="selectedtabs !== 'failed' ? 'requestlistongoing' : 'requestlistfailed'">
        <div class="col1" :class="[{'bc_blue' : item.service_head === 'OCEAN'}, {'bc_deepgreen' : item.service_head === 'LAND'}, {'bc_green' : selectedtabs === 'complete'}]">
          <div class="row m-0 h-100">
            <img :src="getImageShipment(item.service_head)" alt="" width="35" height="67">
            <div class="col-md pr-0">
              <p class="created_at">{{getDateDefauld(item.created_at)}}</p>
              <p class="shipment_type">{{item.rfqnumber ? 'RFQ' : 'CONTRACT'}}</p>
              <p class="ref_number">{{item.rfqnumber || item.contract_number}}</p>
            </div>
          </div>
        </div>
        <div class="col-md col2" :class="[{'color_blue' : item.service_head === 'OCEAN'}, {'color_deepgreen' : item.service_head === 'LAND'}, {'color_green' : selectedtabs === 'complete'}]">
          <div class="row m-0 h-100">
            <div class="col-md-5 col2-1">
              <p class="route">{{item.cityf}} ({{item.country_from}}) to {{item.cityt}} ({{item.country_to}})</p>
              <p v-if="item.service_head !== 'LAND'" class="shipment_service">{{getShipmentType(item.shipment_type)}} - {{getServiceType(item.optiontp)}}</p>
              <p v-else class="shipment_service">Shipping Land</p>
              <p class="shipping_date" v-if="item.rfqnumber">Shipping Date : {{getDateDefauld(item.cargo_readynes_date)}}</p>
              <p class="shipping_date" v-else>Contract Duration : {{getDateDefauld(item.duration_start)}} - {{getDateDefauld(item.duration_end)}}</p>
            </div>
            <div class="col-md-4 col2-2">
              <p class="expired_date mb-1"
                v-if="selectedtabs === 'rfq' || selectedtabs === 'contract' && getStatus(item) !== 'On Going'"
                :class="{'color_red' : item.request_expired < today}">
                {{item.rfqnumber ? 'RFQ' : 'Contract'}}
                Expired Date: {{getDateDefauld(item.request_expired)}}
              </p>
              <div class="row m-0 action__button">
                <a class="button" @click="seeDetails(item)" :class="selectedtabs === 'complete' ? 'button_bordergreen' : item.service_head === 'OCEAN' ? 'button_blue' : item.service_head === 'LAND' ? 'button_deepgreen' : 'button_purple'">
                    See Details
                </a>
                <router-link tag="a" class="button button_green" v-if="selectedtabs === 'complete' && item.rfqnumber"
                :to="{name: 'ManagementShipmentDetail', params: {id_shipment: item.shipmentId, order_number: item.orderNumber.split('/').join('-') }}">
                    Manage Shipment
                </router-link>
                <button v-if="selectedtabs === 'contract' && getStatus(item) === 'On Going'"
                  @click="fetchShipmentDetail(item.id)"
                  class="button" :class="item.service_head === 'OCEAN' ? 'button_borderblue' : item.service_head === 'LAND' ? 'button_borderdeepgreen' : 'button_borderpurple'">
                  Add Shipment
                </button>
                <!-- tab selain tab failed  -->
                <div  v-if="(selectedtabs === 'rfq' || selectedtabs === 'contract') && getStatus(item) !== 'On Going'">
                  <button v-if="item.request_expired < today"
                     @click="extendRequest(item)"
                     class="button" :class="item.service_head === 'OCEAN' ? 'button_borderblue' : item.service_head === 'LAND' ? 'button_borderdeepgreen' : 'button_borderpurple'">
                      Extend
                  </button>
                  <button v-else class="button" @click="cancelRequest(item.id, item.rfqnumber ? 'RFQ' : 'Contract')"
                    :class="item.service_head === 'OCEAN' ? 'button_borderblue' : item.service_head === 'LAND' ? 'button_borderdeepgreen' : 'button_borderpurple'">
                      Cancel
                  </button>
                </div>
              </div>

            </div>
            <div class="col-md-3 col2-3 text-center">
              <img :class="[{'img__purple' : item.service_head === 'AIR'},
                            {'img__deepgreen' : item.service_head === 'LAND'},
                            {'img__green' : selectedtabs === 'complete'},
                            {'img__gray' : selectedtabs === 'failed'}]"
                   :src="getImageStatus(item)" alt="">
              <img class="img__canceled" v-if="selectedtabs === 'failed'" :src="getImageFailed(item)" alt="">
              <p class="mt-1" :class="selectedtabs === 'failed' ? 'status__fail' : 'status'" >{{getStatus(item)}}</p>
              <div class="mt-2 status__fail" v-if="selectedtabs === 'failed' && item.reasonRejected">
                <p class="font-weight-bold">{{item.reasonRejected}}</p>
                <p v-if="item.updated_at">{{getDateDefauld(item.updated_at)}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-1 p-0 col3">
          <div class="bg_top" :class="[{'bc_blue' : item.service_head === 'OCEAN'}, {'bc_deepgreen' : item.service_head === 'LAND'},  {'bc_green' : selectedtabs === 'complete'}]"
          :style="getProgress(item.percentage, 'top')"></div>
          <div class="bg_bottom" :class="[{'bc_blue' : item.service_head === 'OCEAN'}, {'bc_deepgreen' : item.service_head === 'LAND'},  {'bc_green' : selectedtabs === 'complete'}]"
          :style="getProgress(item.percentage, 'bottom')"></div>
          <div class="progress" :class="[{'color_blue' : item.service_head === 'OCEAN'}, {'color_deepgreen' : item.service_head === 'LAND'}, {'color_green' : selectedtabs === 'complete'}]">
            <p>{{item.percentage}}%</p>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row m-0 mb-2" v-for="(item, i) in requestList" :key="i" :class="selectedtabs !== 'failed' ? 'requestlistongoing' : 'requestlistfailed'">
        <div class="col1" 
        :class="selectedtabs === 'complete' ? 'bc_green' : 'bc_blue'"
        >
          <div class="row m-0 h-100">
            <img :src="getImageShipment('OCEAN')" alt="" width="35" height="67">
            <div class="col-md pr-0">
              <p class="shipment_type">Instant Quote</p>
              <p class="created_at">{{getDateDefauld(item.createdAt)}}</p>
              <p class="ref_number">{{item.requestNumber}}</p>
            </div>
          </div>
        </div>
        <div class="col-md col2" :class="selectedtabs === 'complete' ? 'color_green' : 'color_blue'">
          <div class="row m-0 h-100">
            <div class="col-md-5 col2-1">
              <p class="route">{{item.originCityName}} ({{item.originCountryCode}}) to {{item.destinationCityName}} ({{item.destinationCountryCode}})</p>
              <p class="shipment_service">{{getShipmentType(item.shipmentType)}} {{ item.containerType }}</p>
              <p class="shipping_date">Shipment Type : {{getServiceType(item.shipmentService)}}</p>
            </div>
            <div class="col-md-4 col2-2">
              <div class="row m-0 action__button">
                <a v-if="selectedtabs === 'instant-quote' && item.requestStatus === 'ONGOING'" class="button" @click="placeOrder(item)" 
                :class="selectedtabs === 'complete' ? 'button_bordergreen' : 'button_blue'">
                  Book Now
                </a>
                <router-link v-if="tabActiveFailed === 'Instant-Quote' && item.requestStatus !== 'REJECTED' && item.requestStatus !== 'FAILED'" class="button"
                :to="{name: 'ManagementShipmentDetail', params: {id_shipment: item.shipmentId, order_number: item.orderNumber.split('/').join('-') }}"
                :class="selectedtabs === 'complete' ? 'button_green' : 'button_blue'">
                  Manage Shipment
                </router-link>
                <a class="button" @click="seeDetails(item)" 
                :class="selectedtabs === 'complete' ? 'button_bordergreen' : 'button_borderblue'">
                  See Details
                </a>
                <!-- tab selain tab failed  -->
              </div>

            </div>
            <div class="col-md-3 col2-3 text-center">
              <img v-if="selectedtabs === 'instant-quote' && item.requestStatus === 'ONGOING'"
                class="img__blue"
                src="@/assets/image/icon/ready-to-book.svg" 
                alt=""
              >
              <img v-else-if="selectedtabs === 'instant-quote' && item.requestStatus === 'VALIDATING'"
                class="img__blue"
                src="@/assets/image/icon/instant-quote-validating.svg" 
                alt=""
              >
              <img v-else
                :class="selectedtabs === 'complete' ? 'img__green' : 'img__gray'"
                src="@/assets/image/icon/instant-booked.svg" 
                alt=""
              >
              <img v-if="selectedtabs === 'failed'" 
              class="img__canceled"  
              :src="getImageFailed(item)"
              alt="">
              <p v-if="selectedtabs=='instant-quote' && item.requestStatus === 'ONGOING'" class="mt-1 status">Ready to Book</p>
              <p v-else-if="selectedtabs=='instant-quote' && item.requestStatus === 'VALIDATING'" class="mt-1 status">Validating</p>
              <p v-else-if="selectedtabs=='complete'" class="mt-1 status">Completed</p>
              <p v-else class="mt-1 status__fail">Failed</p>
              <div class="mt-2 status__fail" v-if="selectedtabs === 'failed'">
                <p class="font-weight-bold">{{item.reasonRejected}}</p>
                <p v-if="item.updated_at">{{getDateDefauld(item.updated_at)}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-1 p-0 col3">
          <div class="bg_top" :class="selectedtabs === 'complete' ? 'bc_green' : 'bc_blue'"
          :style="getProgress(item.percentage, 'top')"></div>
          <div class="bg_bottom" :class="selectedtabs === 'complete' ? 'bc_green' : 'bc_blue'"
          :style="getProgress(item.percentage, 'bottom')"></div>
          <div class="progress" :class="selectedtabs === 'complete' ? 'color_green' : 'color_blue'">
            <p>{{item.percentage}}%</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixinGetters from '@/mixin/getters/date-time'
import mixinShipment from '@/mixin/getters/shipment-details'
import mixinStatus from '@/mixin/getters/status-bid'
import { mapGetters } from 'vuex'
import moment from 'moment'
export default {
  name: 'List',
  props: {
    requestList: Array,
    selectedtabs: String,
    tabActiveFailed: String
  },
  data: () => ({
    today: moment().format('YYYY-MM-DD')
  }),
  mixins: [mixinGetters, mixinShipment, mixinStatus],
  methods: {
    async fetchShipmentDetail (id) {
      await this.$store.dispatch('contract/FETCH_CONTRACT_BY_ID', id)
      await this.$store.dispatch('contract/GET_CONTRACT_DETAIL', id)
      await this.$store.dispatch('contract/FETCH_BID_CONTRACT', id)
    },
    seeDetails (item) {
      if (this.selectedtabs === 'rfq' || ((this.selectedtabs === 'failed' || this.selectedtabs === 'complete') && this.tabActiveFailed === 'RFQ')) {
        this.$router.push({ name: 'RequestListStatusRFQ', params: { id_rfq: item.id, rfqNumber: item.rfqnumber.split('/').join('-') } })
      } else if (this.selectedtabs === 'contract' || ((this.selectedtabs === 'failed' || this.selectedtabs === 'complete') && this.tabActiveFailed === 'Contract')) {
        this.$router.push({ name: 'RequestListStatusContract', params: { id_contract: item.id, contractNumber: item.contract_number.split('/').join('-') } })
      } else {
        this.$router.push({ name: 'RequestListStatusIQ', params: { id_iq: item.id, iqNumber: item.requestNumber.split('/').join('-') } })
      }
    },
    getImageShipment (type) {
      if (type === 'OCEAN') {
        return require('@/assets/image/icon/shipment-ocean.svg')
      }
      if (type === 'LAND') {
        return require('@/assets/image/icon/shipment-land.svg')
      }
      return require('@/assets/image/icon/shipment-air.svg')
    },
    getProgress (item, type) {
      let percentage = ''
      if (type === 'bottom') {
        percentage = `height: ${item}%`
      } else {
        const newPercentage = 100 - parseFloat(item)
        percentage = `height: ${newPercentage}%`
      }
      return percentage
    },
    getImageFailed (item) {
      let source = ''
      if (parseInt(item.status) === 3) {
        source = require('@/assets/image/icon/canceled.svg')
      } else if (parseInt(item.status) === 4) {
        source = require('@/assets/image/icon/rejected.svg')
      } else {
        source = require('@/assets/image/icon/failed.svg')
      }
      return source
    },
    getImageStatus (item) {
      let source = ''
      if (parseInt(item.rfq_status) === 4 || parseInt(item.rfq_status) === 7 || parseInt(item.rfq_status) === 11 || item.rfq_status === null || item.contract_status === null || parseInt(item.contract_status) === 4 || parseInt(item.contract_status) === 11) {
        source = require('@/assets/image/icon/time-left.svg')
      } else if (parseInt(item.rfq_status) === 1 || parseInt(item.rfq_status) === 9 || parseInt(item.rfq_status) === 6 || parseInt(item.contract_status) === 1 || parseInt(item.contract_status) === 2) {
        source = require('@/assets/image/icon/submited.svg')
      } else if (parseInt(item.rfq_status) === 2 || parseInt(item.rfq_status) === 0 || parseInt(item.rfq_status) === 8 || parseInt(item.rfq_status) === 10 || parseInt(item.contract_status) === 8 || parseInt(item.contract_status) === 7 || parseInt(item.contract_status) === 10 || parseInt(item.contract_status) === 0) {
        source = require('@/assets/image/icon/checking.svg')
      } else if ((parseInt(item.contract_status) === 3 && this.today <= moment(item.duration_end).format('YYYY-MM-DD'))) {
        source = require('@/assets/image/icon/ongoing.svg')
      } else if (parseInt(item.rfq_status) === 3 || parseInt(item.contract_status) === 3) {
        source = require('@/assets/image/icon/complate.svg')
      }
      return source
    },
    cancelRequest (idRequest, typeRequest) {
      this.$eventHub.$emit('dialog-request-cancel', idRequest, typeRequest)
    },
    extendRequest (item) {
      const idRequest = item.id
      const typeRequest = item.rfqnumber ? 'RFQ' : 'Contract'
      const numberRequest = item.rfqnumber ? item.rfqnumber : item.contract_number
      this.$eventHub.$emit('dialog-request-extend', idRequest, numberRequest, typeRequest)
    },
    placeOrder (item) {
      const params = {
        type: 'iq',
        id: item.id
      }
      this.$router.push({ name: 'BookingForm', params })
    }
  },
  computed: {
    ...mapGetters({
      isLoadingRfq: 'rfq/isLoading',
      isLoadingRfqFilter: 'rfq/isLoadingRfqFilter',
      isLoadingContract: 'contract/isLoading',
      isLoadingContractFilter: 'contract/isLoadingContractFilter',
      contractDetail: 'contract/item',
      isLoadingIq: 'instantQuote/isLoading',
      isLoadingIqFilter: 'instantQuote/isLoadingRfqFilter'
    })
  },
  watch: {
    contractDetail (item) {
      if (item) {
        const remainingDays = parseInt(item.remaining_days)
        const estimateContractValue = parseInt(item.estimate_contract_value)
        if (remainingDays > 0 && estimateContractValue !== 0) {
          this.$eventHub.$emit('dialog-add-shipment', item.shipment_type, item.duration_start, item.duration_end)
        } else {
          this.$eventHub.$emit('dialog-cant-addshipment', remainingDays, estimateContractValue)
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/requestList/List.vue